import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import parse from "html-react-parser";
import LayoutContainer from "../../../components/LayoutsContainer";
import PagesTitle from "../../../components/Common/PagesTitle";
import UseMobile from "../../../hooks/useIsMobile";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
    [theme.breakpoints.down("md")]: {
      padding: "10px 0vw",
      backgroundColor: "#f6f6f6",
    },
  },
  aboutUsImage: {
    height: "50vh",
    width: "100%",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: "200px",
    },
  },
  TitleContainer: {
    marginBottom: theme.spacing(2),
  },
}));

const AboutUsLayout = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  return (
    <div className={classes.root}>
      <LayoutContainer>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <img src={data.imageSrc} className={classes.aboutUsImage} />
          </Grid>

          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            container
            direction="column"
            alignItems={isMobile ? "center" : "flex-start"}
          >
            <Grid item className={classes.TitleContainer}>
              <PagesTitle title={data.title} />
            </Grid>

            <Grid item>
              <Typography>
                {data.data ? parse(data.data) : undefined}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </LayoutContainer>
    </div>
  );
};
export default AboutUsLayout;
